import React from "react"

export const TermineUndFristenIcon = (props) => {
  return (
    <svg
      width={32}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={0.832}
        y={12.123}
        width={29.916}
        height={14.655}
        rx={0.829}
        fill="#FFD62E"
      />
      <mask id="a" fill="#fff">
        <rect y={4.09} width={32} height={23.91} rx={0.861} />
      </mask>
      <rect
        y={4.09}
        width={32}
        height={23.91}
        rx={0.861}
        stroke="#035470"
        strokeWidth={3.6}
        mask="url(#a)"
      />
      <path
        d="M24.477 8.484V0M6.837 8.484V0M1.176 11.79h29.656M18.949 16.879h5.069v5.142h-5.069zM7.5 16.879h5.069v5.142H7.5z"
        stroke="#035470"
        strokeWidth={1.8}
      />
    </svg>
  )
}
